import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { of, ReplaySubject, Subject } from 'rxjs';
import { catchError, debounceTime, delay, distinctUntilChanged, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { IExternalEntity, IExternalEntityCriteria } from 'src/app/masters/peoples/external-entity/external-entity.interface';
import { IDestination } from 'src/app/masters/places/destination/destination.interface';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow, IRequest } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';
import { IVesselCriteria } from '../../vessel/vessel.interface';
import { IDestinationIndex, ILineIndex, Ivessel } from '../consortium.interface';
import {CustomValidator} from '../../../../shared/validators/custom-validator';

@Component({
    selector: 'app-consortium-form',
    templateUrl: './consortium-form.component.html',
    styleUrls: ['./consortium-form.component.less'],
    standalone: false
})
export class ConsortiumFormComponent implements OnInit {

  constructor(private logger:NGXLogger,private formBuilder:FormBuilder,
              private service:DataService,private router:Router,private utilityService:UtilityService,
              private activatedRoute:ActivatedRoute,
              private dailog:MatDialog, private permissionService:PermissionService) { }

  consortiumForm:FormGroup;
  filteredLines:ReplaySubject<IExternalEntity[]> = new ReplaySubject<IExternalEntity[]>(1);
  filteredDestinations:ReplaySubject<IDestination[]> = new ReplaySubject<IDestination[]>(1);
  filteredVessel:ReplaySubject<Ivessel[]> = new ReplaySubject<Ivessel[]>(1);
  lineSearchCtrl = this.formBuilder.control('');
  selectedDestinations=[];
  selectedLinesIndex:ILineIndex[]=[];
  selectedDestinationsIndex:IDestinationIndex[]=[];
  lines=[];
  vessels=[];
  consortiumData:any;
  onDestroy = new Subject<void>();
  modes:any;
  showStatus:string;
  showDeactivateToggle=false;
  showReactivateToggle=false;
  checked:boolean=false;
  destinations:IDestination[]=[];
  portOfLoadings:any;
  vesselCriteria:IVesselCriteria={};
  vesselSearchCtrl= this.formBuilder.control('');
  lineCriteria:IExternalEntityCriteria={};
  disableSubmit:boolean=false;
  editPermission:boolean=false;
  addPermission:boolean=false;
  deactivatePermission:boolean=false;
  reactivatePermission:boolean=false;
  @Input() searching: boolean = false;
  viewLog=this.formBuilder.control(false);
  currentDestinationList:any[]=[];
  destinationIds: any;
  private selectedDestinationIds: Set<number> = new Set();
  private selectedServicePairs: Set<string> = new Set();
  private usedServiceLocationIds: Set<any> = new Set();

  ngOnInit() {
    this.viewLog.setValue(false);
    this.getAllPermissions();
    this.initializeForm();
    this.activatedRoute.params.subscribe(
      (param:Params) => {
        if(+param['id'])
          this.id.setValue(+param['id']);
    });
    this.getVesselList();
    this.callForkedJoin();
    this.filterLines();
    this.filtredVessel();
  }

  initializeForm(){
    this.consortiumForm=this.formBuilder.group({
      id:[],
      name:[null,[Validators.required,CustomValidator.whiteSpaceValidator]],
      status:[],
      activeFlag:[],
      parentId:[],
      vesselDetails:this.formBuilder.array([this.consortiumVesselForm()]),
      destinationDetails:this.formBuilder.array([this.consortiumDestinationForm()]),
      lineDetails:this.formBuilder.array([this.consortiumLineForm()]),
      consortiumServiceDetails:this.formBuilder.array([this.consortiumServiceForm()]),

    });
    this.disableDeactivateField();
  }

  disableDeactivateField(){
    this.vesselDetails.at(0).get('deactivated').disable();
    this.lineDetails.at(0).get('deactivated').disable();
    this.destinationDetails.at(0).get('deactivated').disable();
    this.consortiumServiceDetails.at(0).get('deactivated').disable();
 }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  consortiumLineForm(data?:any):FormGroup{
    return this.formBuilder.group({
      lineId:[data?data.lineId:null,[Validators.required]],
      lineName:[data?data.lineName:null],
      deactivated:[data?data.deactivated:null],
    })
  }

  filterLines() {
    this.lineSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(300),
        map(search => {
          if (!this.lines) { return []; }
          if(!search) { this.filteredLines.next(this.lines); }
          return this.lines.filter(line =>
            line.name.toLowerCase().indexOf(search.toLowerCase()) > -1
            || line.code.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }),
        delay(200)
      )
      .subscribe(filteredLines => {
        this.searching = false;
        this.filteredLines.next(filteredLines);
      },
      error => { this.searching = false; });
  }

  // destinationSearch(index:number,event:any){
  //   this.logger.info('Destination Value',event.value);
  //   ((this.destinationDetails.get('controls') as FormArray).at(index) as FormGroup).get('destinationId').valueChanges.subscribe(value => {
  //      this.logger.info('Destination Value',value);
  //   })
  // }

  lineChanged(index:number,value:any){
    // let proceed: boolean = this.checkLineCondition(index);
    let alreadySelected=_.where(this.lineDetails.getRawValue(),{lineId:value});
    if(alreadySelected.length>1){
      this.lineDetails.at(index).reset();
      this.utilityService.notifier('Line Already Selected','warning');
    } else {
        value ? this.setLineNameAndLineByIndex(value, index) : this.lineDetails.at(index).get('lineName').reset();
    }
  }

  private setLineNameAndLineByIndex(value: any, index: number) {
    let line = _.findWhere(this.lines, { id: value });
    this.lineDetails.at(index).get('lineName').setValue(line.name);
    let lineByIndex = _.findWhere(this.selectedLinesIndex, { index: index });
    if (!lineByIndex) {
      this.selectedLinesIndex.push({ index: index, value: value });
    } else {
      lineByIndex.index = index;
      lineByIndex.value = value;
    }
    // let lineIds = this.lineDetails.getRawValue().map(obj => obj.lineId);
    // this.setVesselCriteria(lineIds);
  }

  private checkLineCondition(index: number) {
    let lineByIndex = _.findWhere(this.selectedLinesIndex, { index: index });
    if (lineByIndex) {
      let selectedVesselByLine = _.where(this.vessels, { operatorId: lineByIndex.value, isSelected: true });
      if (selectedVesselByLine.length > 0) {
        this.lineDetails.at(index).get('lineId').setValue(lineByIndex.value);
        this.utilityService.notifier('Vessel of particular Line Already Selected', 'warning');
        return false;
      }
    }
    return true;
  }

  addLineField(item:any){
    if(item.invalid){
      item.markAllAsTouched();
      return;
    }
    let lineForm=this.consortiumLineForm();
    lineForm.get('deactivated').disable();
    this.lineDetails.push(lineForm);
  }

  removeLineField(index:number){
    // if(this.lineDetails.length==1 || this.lineDetails.at(index).get('lineId').disabled){
    //   return;
    // }
    // let proceed: boolean = this.checkLineCondition(index);
    // if(proceed){
    //   this.lineDetails.removeAt(index);
    //   let lineIds = this.lineDetails.getRawValue().map(obj => obj.lineId);
    //   this.setVesselCriteria(lineIds);
    // }
    this.lineDetails.removeAt(index);
  }

  removeLineCondition(index:number){
    if(this.lineDetails.length==1 || this.lineDetails.at(index).get('lineId').disabled){
      return false;
    }
    return true;
  }

   consortiumDestinationForm(data?:any):FormGroup{
    let form= this.formBuilder.group({
       destinationId:[data?data.destinationId:null,[Validators.required]],
       destinationName:[data?data.destinationName:null],
       deactivated:[data?data.deactivated:null],
       destinationSearch:[],
       destinationList:[this.destinations]
    })
    this.filterPod(form);
    return form;
  }

  public searchValueChangeInFormArray(form:any,searchControlName:any,selectListControlName:any){
    form.get(searchControlName).valueChanges.pipe(takeUntil(this.onDestroy)).subscribe((searchText: string) => {
      const items = this.destinations;
      if (searchText) {
        form.get(selectListControlName).setValue(
          items.filter((item) => item.name.toLowerCase().includes(searchText.toLowerCase()) ||
                                    item.code.toLowerCase().includes(searchText.toLowerCase())),
        );
      } else {
        form.get(selectListControlName).setValue(items);
      }
    });
  }


  destinationChanged(index:number,value:any){
    this.setPodValueChnageEvent(value,this.destinationDetails.at(index));
    if(this.checkDestinationProceedCondition(index)) {
      this.setIsSelected(value,index);
    }
    if (value) {
      const destination = this.destinations.find(d => d.id === value);
      if (destination) {
        this.addDestinationToLists(destination);
        this.destinationDetails.at(index).get('destinationName').setValue(destination.name);
      }
    }
  }

  private checkDestinationProceedCondition(index: number) {
    let destinationByIndex = _.findWhere(this.selectedDestinationsIndex, { index: index });
    if (destinationByIndex) {
      if (this.usedServiceLocationIds.has(destinationByIndex.value)) {
        this.destinationDetails.at(index).get('destinationId').setValue(destinationByIndex.value);
        this.utilityService.notifier('Destination Already Selected in Services', 'warning');
        return false;
      }
    }
    return true;
  }

  private setIsSelected(value: any,index) {
    let destinationByIndex=_.findWhere(this.selectedDestinationsIndex,{index:index});
    let destinationById=_.findWhere(this.destinations,{id:value});
    if(!destinationByIndex){
      this.selectedDestinationsIndex.push({index:index,value:value})
    } else {
      destinationByIndex.index=index;
      destinationByIndex.value=value;
    }
    this.destinationDetails.at(index).get('destinationName').setValue(destinationById?.name);
    this.destinations.forEach(v => v.isSelected = false);
    this.destinationDetails.controls.forEach(control => {
      let destination = _.findWhere(this.destinations, { id: control.get('destinationId').value });
      if(destination)
         destination.isSelected = true;
    });
    this.refreshSelectedDestinationIds();
  }

  private refreshSelectedDestinationIds(): void {
    const ids = new Set<number>();
    this.destinationDetails.controls.forEach(control => {
      const destinationId = control.get('destinationId').value;
      if (destinationId != null) {
        ids.add(destinationId);
      }
    });
    this.selectedDestinationIds = ids;
  }

  private refreshServiceDetailCaches(): void {
    const pairs = new Set<string>();
    const usedIds = new Set<any>();
    this.consortiumServiceDetails.controls.forEach(control => {
      const portId = control.get('portId').value;
      const destinationId = control.get('destinationId').value;
      if (portId != null) { usedIds.add(portId); }
      if (destinationId != null) { usedIds.add(destinationId); }
      pairs.add(`${portId}|${destinationId}`);
    });
    this.selectedServicePairs = pairs;
    this.usedServiceLocationIds = usedIds;
  }

  addDestinationField(){
    if(this.destinationDetails.invalid){
      this.destinationDetails.markAllAsTouched();
      return;
    }
    let destinationForm=this.consortiumDestinationForm();
    destinationForm.get('deactivated').disable();
    this.selectedDestinationsIndex.forEach(entry => entry.index++);
    this.destinationDetails.insert(0, destinationForm);
  }

  removeDestinationField(index:number){
    // if(this.destinationDetails.length==1 || this.destinationDetails.at(index).get('destinationId').disabled){
    //   return;
    // }
    let proceed: boolean = this.checkDestinationProceedCondition(index);
    if(proceed){
      let destinationByIndex=this.destinationDetails.at(index).value;
      if(destinationByIndex.destinationId){
        let destination = _.findWhere(this.destinations,{id:destinationByIndex.destinationId});
        destination.isSelected=false;
        this.filteredDestinations.next(this.destinations);
      }
      this.destinationDetails.removeAt(index);
      this.selectedDestinationsIndex = this.selectedDestinationsIndex
        .filter(entry => entry.index !== index)
        .map(entry => entry.index > index ? { ...entry, index: entry.index - 1 } : entry);
      this.refreshSelectedDestinationIds();
    }
  }

  getRemoveDestinationCond(index:number){
    if(this.destinationDetails.length==1 || this.destinationDetails.at(index).get('destinationId').disabled){
      return false;
    }
    return true;
  }

  checkDestinationOptionDisable(d:any,item:any){
    if(item.get('destinationId').value===d.id){
      return false;
    }
    return this.selectedDestinationIds.has(d.id);
  }

  destinationDeactivateChanged(index:number,item:any){
    let value=item.get('deactivated').value;
    let destinationById =this.destinationDetails.at(index).get('destinationId').value;
    _.findWhere(this.destinations,{id:destinationById}).isDeactivated=value;
    this.filteredDestinations.next(this.destinations);
    this.setDeactivateValueInServices(destinationById,value);
  }

  setDeactivateValueInServices(id:number,value:boolean){
    this.consortiumServiceDetails.controls.forEach(control => {
      if(control.get('portId').value==id || control.get('destinationId').value==id){
        control.get('deactivated').setValue(value);
      }
    });
  }

  private consortiumVesselForm(data?:any):FormGroup{
    return this.formBuilder.group({
      vesselId:[data?data.vesselId:null,[Validators.required]],
      vesselName:[data?data.vesselName:null],
      deactivated:[data?data.deactivated:null],
    })
  }

  // private setVesselCriteria(ids:any){
  //   this.vesselCriteria.operatorIds=ids;
  //   this.vesselCriteria['activeFlag.equals']=true;
  //   this.getVesselList();
  // }

  vesselChanged(index:number,value:number){
    let alreadySelected=_.where(this.vesselDetails.getRawValue(),{vesselId:value});
    if(alreadySelected.length>1){
      this.vesselDetails.at(index).reset();
      this.utilityService.notifier('Vessel Already Selected','warning');
    } else {
       this.setVesselIsSelected();
    } 
  }

  private setVesselIsSelected() {
    this.vessels= this.vessels.map(v => ({...v, isSelected: false}));
    this.vesselDetails.getRawValue().forEach(element => {
      let vessel = _.findWhere(this.vessels, { id: element.vesselId });
      vessel.isSelected = true;
    });
  }

  addVesselField(item:any){
    if(item.invalid){
      item.markAllAsTouched();
      return;
    }
    let vesselForm=this.consortiumVesselForm();
    vesselForm.get('deactivated').disable();
    this.vesselDetails.push(vesselForm);
  }

  removeVesselField(index:number){
    // if(this.vesselDetails.length==1 || this.vesselDetails.at(index).get('vesselId').disabled){
    //   return;
    // }
    this.vesselDetails.removeAt(index);
    this.setVesselIsSelected();
  }

  removeVesselCondition(index:number){
    if(this.vesselDetails.length==1 || this.vesselDetails.at(index).get('vesselId').disabled){
      return false;
    }
    return true;
  }

  consortiumServiceForm(data?:any, destinationList: any[] = []):FormGroup{
     let form= this.formBuilder.group({
      code:[data?data.code:null],
      destinationId:[data?data.destinationId:null,[Validators.required]],
      destinationSearch:[],
      destinationList:[destinationList],
      destinationName:[data?data.destinationName:null],
      deactivated:[data?data.deactivated:null],
      portId:[data?data.portId:null,[Validators.required]],
      portSearch:[],
      portList:[destinationList],
      portName:[data?data.portName:null],
      mode:[data?data.mode:null,[Validators.required]],
      transitTime:[data?data.transitTime:null,[Validators.required,Validators.pattern('^[1-9]+[0-9]*$')]],
      arrivalDayPol:[data?data.arrivalDayPol:null,[Validators.required]],
      departureDayPol:[data?data.departureDayPol:null,[Validators.required]],
      arrivalDayDestination:[data?data.arrivalDayDestination:null,[Validators.required]]
     })
      this.searchValueChangeInFormArray(form,'destinationSearch','destinationList');
      this.searchValueChangeInFormArray(form,'portSearch','portList');
     return form;
  }

  addServiceField() {
    if(this.consortiumServiceDetails.invalid) {
      this.consortiumServiceDetails.markAllAsTouched();
      return;
    }
    this.currentDestinationList = this.destinations || [];
    const serviceForm = this.consortiumServiceForm({}, this.currentDestinationList);
    serviceForm.get('deactivated').disable()
    this.consortiumServiceDetails.insert(0, serviceForm);
    this.refreshServiceDetailCaches();
  }


  removeServiceField(index:number){
    // if(this.consortiumServiceDetails.length==1 || this.consortiumServiceDetails.at(index).get('code').disabled){
    //   return;
    // }
    this.consortiumServiceDetails.removeAt(index);
    this.refreshServiceDetailCaches();
  }

  removeServiceCondition(index:number){
    if(this.consortiumServiceDetails.length==1 || this.consortiumServiceDetails.at(index).get('code').disabled){
      return false;
    }
    return true;
  }

  servicePortChanged(item:any,index:number){
    this.checkConsortiumServiceRowValidation(item, index);
  }

  private checkConsortiumServiceRowValidation(item: FormGroup, index: number) {
    if (item.get('portId').value && item.get('destinationId').value) {
      const portId = item.get('portId').value;
      const destinationId = item.get('destinationId').value;
      const matchCount = this.consortiumServiceDetails.controls
        .filter(control => control.get('portId').value === portId && control.get('destinationId').value === destinationId)
        .length;
      if (matchCount>1) {
        this.utilityService.notifier('Consortium Service With particular Port and Destination Already Exists', 'warning');
        this.consortiumServiceDetails.at(index).reset();
        this.consortiumServiceDetails.at(index).get('destinationList').setValue(this.destinations);
        this.consortiumServiceDetails.at(index).get('portList').setValue(this.destinations);
      }
    }
    this.refreshServiceDetailCaches();
  }

  serviceDestinationChanged(item:any,index:number){
    this.checkConsortiumServiceRowValidation(item, index);
  }

  checkDeactivateCondition(item:any,index:number){
     if(item.get('destinationId').value || item.get('portId').value){
        if(item.get('destinationId').value){
           let destinationById = _.findWhere(this.destinationDetails.getRawValue(),{destinationId:item.get('destinationId').value});
           if(destinationById?.deactivated){
            // this.consortiumServices.at(index).get('deactivate').setValue(true);
            return true;
           }
        }
        if(item.get('portId').value){
          let destinationByPortId = _.findWhere(this.destinationDetails.getRawValue(),{destinationId:item.get('portId').value});
          if(destinationByPortId?.deactivated){
            // this.consortiumServices.at(index).get('deactivate').setValue(true);
            return true;
          }
        }    
     } 
     this.consortiumServiceDetails.at(index).get('deactivated').reset();
     return false;
  }

  checkPortDisableCondition(d:any,port:any){
     if(!d.isSelected || port.get('destinationId').value==d.id || d.isDeactivated){
       return true;
     }
     let destinationId = port.get('destinationId').value;
     if(destinationId && this.isDuplicateServicePair(d.id, destinationId)){
       return true;
     }
     return false;
  }

  checkDestinationDisableCondition(d:any,destination:any){
    if(!d.isSelected || destination.get('portId').value==d.id || d.isDeactivated){
      return true;
    }
    let portId = destination.get('portId').value;
    if(portId && this.isDuplicateServicePair(portId, d.id)){
      return true;
    }
    return false;
  }

  private isDuplicateServicePair(portId:any,destinationId:any){
    return this.selectedServicePairs.has(`${portId}|${destinationId}`);
  }

  checkDeactivateChange(item:any,index:number,event:any){
     item.get('deactivated').setValue(event.checked);
  }

  prepareConsortiumByIdRequest(requests){
    let request:IRequest={url:Api.CONSORTIUM+'/'+this.id.value,method:'get'};
    requests.push(request);
  }

  getConsortiumById(consortium: any) {
    this.consortiumData = consortium;
    this.loadDestinationList(consortium.destinationDetails);
    this.showStatus = this.getStatus(consortium);
    this.consortiumForm.patchValue(consortium);
    this.patchLineValues(consortium);
    this.patchVesselValues(consortium);
    this.patchServiceValues(consortium);
    if(consortium.submittedForApproval || consortium.status==='DEACTIVATED' || !this.editPermission){
      this.consortiumForm.disable();
      this.disableSubmit=true;
    }
  }
  
  private patchLineValues(res: any) {
    this.lineDetails.removeAt(0);
    const disableOptions = { onlySelf: true, emitEvent: false };
    res.lineDetails.forEach((element,index) => {
      this.lineDetails.push(this.consortiumLineForm(element));
      this.lineDetails.at(index).disable(disableOptions);
      this.lineDetails.at(index).get('deactivated').enable(disableOptions);
      this.lineChanged(index,element.lineId);
    });
    this.lineDetails.updateValueAndValidity({ emitEvent: false });
    // let lineIds = this.lineDetails.getRawValue().map(obj => obj.lineId);
    // this.setVesselCriteria(lineIds);
  }

  private patchVesselValues(res: any) {
    this.vesselDetails.removeAt(0);
    const disableOptions = { onlySelf: true, emitEvent: false };
    res.vesselDetails.forEach((element,index) => {
      this.vesselDetails.push(this.consortiumVesselForm(element));
      this.vesselDetails.at(index).disable(disableOptions);
      this.vesselDetails.at(index).get('deactivated').enable(disableOptions);
    });
    this.vesselDetails.updateValueAndValidity({ emitEvent: false });
  }

  private patchDestinationValues(res: any) {
    this.destinationDetails.removeAt(0);
    const disableOptions = { onlySelf: true, emitEvent: false };
    res.destinationDetails.forEach((element,index) => {
      this.destinationDetails.push(this.consortiumDestinationForm(element));
      this.destinationDetails.at(index).disable(disableOptions);
      this.destinationDetails.at(index).get('deactivated').enable(disableOptions);
      this.destinationChanged(index,element.destinationId);
      this.destinationDeactivateChanged(index,this.destinationDetails.at(index));
    });
    this.destinationDetails.updateValueAndValidity({ emitEvent: false });
  }

  private patchServiceValues(res: any) {
    this.consortiumServiceDetails.removeAt(0);
    const disableOptions = { onlySelf: true, emitEvent: false };
    res.consortiumServiceDetails.forEach((element,index) => {
      this.consortiumServiceDetails.push(this.consortiumServiceForm(element));
      this.consortiumServiceDetails.at(index).disable(disableOptions);
      this.consortiumServiceDetails.at(index).get('deactivated').enable(disableOptions);
      this.consortiumServiceDetails.at(index).get('mode').enable(disableOptions);
      this.consortiumServiceDetails.at(index).get('transitTime').enable(disableOptions);
      this.consortiumServiceDetails.at(index).get('arrivalDayPol').enable(disableOptions);
      this.consortiumServiceDetails.at(index).get('departureDayPol').enable(disableOptions);
      this.consortiumServiceDetails.at(index).get('arrivalDayDestination').enable(disableOptions);
    });
    this.consortiumServiceDetails.updateValueAndValidity({ emitEvent: false });
    this.refreshServiceDetailCaches();
  }

  private getStatus(data: any) {
    if (data.status == "APPROVED" && !data.submittedForApproval && this.deactivatePermission) {
      this.showDeactivateToggle=true;
      return null;
    }
    else if (data.status == "DEACTIVATED" && !data.submittedForApproval && this.reactivatePermission) {
      this.showReactivateToggle=true;
      return "Deactivated...";
    } else {
      return this.utilityService.getApprovalMessage({status:data.status,
        submittedForApproval: data.submittedForApproval,
        deactivationWefDate: data.deactivate?.deactivationWefDate,
        reactivationWefDate: data.reactivate?.reactivationWefDate});
    }
  }

  onSave()
  {
    this.consortiumForm.markAllAsTouched();
    this.logger.info("Form",this.consortiumForm.value);
    if(this.consortiumForm.valid){
      if(this.id.value){
        this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT,'save');
      }
      else {
        this.openDailog(Message.SAVE_OPEN_DAILOG,'save');
      }  
    }
  }

  saveConsortiumModule()
  {
    let method=(this.id.value)?'put':'post';
    let message=(this.id.value)?'updated':'saved';
    this.service[method](Api.CONSORTIUM,this.consortiumForm.getRawValue()).subscribe(res => {
      this.utilityService.notifier(`Consortium Details ${message} successfully`,'success');
      this.router.navigate([APP_ROUTES.CONSORTIUM_LIST]);
    });
  }

  openDeactivateForm(e:MatSlideToggleChange)
  {
    let data={id:this.id.value,route:APP_ROUTES.CONSORTIUM_LIST,message:'Consortium',api:Api.CONSORTIUM_DEACTIVATE}
    const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
    })    
  }

  openReactivateForm(e:MatSlideToggleChange)
  {
    let data={id:this.id.value,route:APP_ROUTES.CONSORTIUM_LIST,message:'Consortium',api:Api.CONSORTIUM_REACTIVATE}
    const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
    })    
  }
 

  onCancel(){
    if(this.consortiumForm.dirty){
      this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT,'cancel');
    }else{
      this.router.navigate([APP_ROUTES.CONSORTIUM_LIST]);
    }
  }
  
  // export interface IRequest{
  //   url: string;
  //   method: 'post'| 'get' | 'put';
  //   requestBody?: any;
  //   queryParams?: any;
  // }

   callForkedJoin(){
    let requests:IRequest[]=[];
    this.prepareRequestForDestination(requests);
    this.prepareRequestForLineRequests(requests);
    this.prepareRequestForModes(requests);
    this.prepareRequestForPortOfLoading(requests);
    if(this.id.value){
      this.prepareConsortiumByIdRequest(requests);
    }
    this.service.forkJoin(requests).subscribe(res => {
       this.getDestinationList(res[0]);
       this.getLineList(res[1]);
       this.getModes(res[2])
       this.getPortOfLoading(res[3]);
       if(this.id.value){
         this.getConsortiumById(res[4]);
       }
    });
  } 

  prepareRequestForLineRequests(requests:any){
    this.lineCriteria.entityBusinessType='LINE',
    this.lineCriteria.activeFlag=true;
    let request:IRequest={url:Api.EXTERNAL_ENTITY_NAME_FOR_DD,method:'get',queryParams:this.lineCriteria};
    requests.push(request);
  }

  getLineList(res:any){
    this.logger.info('Line res',res);
    this.lines=res;
    this.filteredLines.next(this.lines);
  }

  getVesselList(){
    this.vesselCriteria['activeFlag.equals']=true;
    this.service.get(Api.VESSEL_FOR_DD,this.vesselCriteria).subscribe(res => {
       if(res){
          this.logger.info('Vessel res',res);
          this.vessels=res.map(v => ({...v, isSelected: false}));
          this.filteredVessel.next(this.vessels);
       }
    })
  }

  filtredVessel(){
    this.vesselSearchCtrl.valueChanges.pipe(
      tap(() => this.searching = true),
      takeUntil(this.onDestroy),
      debounceTime(300),
      map(search => {
        if (!this.vessels) { return []; }
        if(!search) { this.filteredVessel.next(this.vessels); }
        return this.vessels.filter(vessel => vessel.name.toLowerCase().indexOf(search?.toLowerCase()) > -1);
      }),
      delay(200)
    )
    .subscribe(filtered => {
      this.searching = false;
      this.filteredVessel.next(filtered);
    },
    error => { this.searching = false; });
  }

  private openDailog(message?:string,mode?:string){
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });

    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
        else {
          if(mode=='cancel') {
            this.router.navigate([APP_ROUTES.CONSORTIUM_LIST]);
          }
          else {
           this.saveConsortiumModule();
          }
        }
    })
  }


  prepareRequestForModes(requests:any){
    let request:IRequest={url:Api.MODE_LIST,method:'get'};
    requests.push(request);
  }

  getModes(res:any){
    this.logger.info('Mode List res',res);
    this.modes=res;
  }

  prepareRequestForPortOfLoading(requests:any){
    let request:IRequest={url:Api.PORT_OF_LOADING,method:'get'};
    requests.push(request);
  }

  getPortOfLoading(res:any){
    this.logger.info('Port of Loading List res',res);
    this.portOfLoadings=res;
  }

  prepareRequestForDestination(requests:any){
    let request:IRequest={url:Api.DESTINATION_NAMES_FOR_DD,method:'get'};
    requests.push(request);
  }

  getDestinationList(res:any){
    this.destinations= res.contents.map(v => ({...v, isSelected: false,isDeactivated:false}));
    this.logger.info('Destinations',this.destinations)
    this.filteredDestinations.next(res.contents);
    this.destinationDetails.at(0).get('destinationList').setValue(this.destinations);
  }

  getSaveBtnCondition(){
    if(this.disableSubmit || (!this.editPermission && this.id.value) || (!this.addPermission && !this.id.value) || !this.consortiumForm.dirty){
      return false;
    }
    return true;
  }

  addDestinationToLists(destination: any) {
    this.consortiumServiceDetails.controls.forEach(control => {
      const portList = control.get('portList').value;
      const destinationList = control.get('destinationList').value;
      if (!portList.some(p => p.id === destination.id)) {
        portList.push(destination);
      }
      if (!destinationList.some(d => d.id === destination.id)) {
        destinationList.push(destination);
      }
      control.get('portList').setValue([...portList]);
      control.get('destinationList').setValue([...destinationList]);
    });
  }

  filterPod(form: FormGroup) {
    form.get('destinationSearch').valueChanges.pipe(
      takeUntil(this.onDestroy),
      map(value => (value || '').toString().trim().toLowerCase()),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value => {
        // cleared search: restore the full list, no server call
        if (!value) {
          return of([...this.destinations]);
        }
        this.searching = true;
        return this.service.get(Api.DESTINATION_NAMES_FOR_DD, { name: value }).pipe(
          map(res => res.contents || []),
          map(filteredResults => filteredResults.map(d => {
            const existing = this.destinations.find(x => x.id === d.id);
            return { ...d, isSelected: existing ? existing.isSelected : false, isDeactivated: existing ? existing.isDeactivated : false };
          })),
          // a failed request must not kill the search stream for this row
          catchError(() => of([...this.destinations]))
        );
      })
    ).subscribe(filteredResults => {
      this.searching = false;
      form.get('destinationList').setValue(filteredResults);
    });
  }
  
  setPodValueChnageEvent(value: number, item?: any) {
    let selectedPod = this.destinations.find(pod => pod.id === value);
    if (!selectedPod && item) {
      selectedPod = (item.get('destinationList').value || []).find(pod => pod.id === value);
    }
    if (selectedPod && !this.destinations.some(pod => pod.id === selectedPod.id)) {
      this.destinations.push(selectedPod);
    }
  }

  loadDestinationList(destinationDetails: any[]) {
    this.destinationIds = destinationDetails?.map(d => d.destinationId) || [];
    if (this.destinationIds.length) {
      this.service.get(Api.DESTINATION_NAMES_FOR_DD, { ids: this.destinationIds, size: this.destinationIds.length }).subscribe(destinations => {
        this.getDestinationList(destinations);
        this.patchDestinationValues(this.consortiumData);
      });
    }
  }

  public getAllPermissions(){
    let permissionCodes=[PermissionKey.CONSORTIUM_MODULE_EDIT_PERMISSION,PermissionKey.CONSORTIUM_MODULE_DEACTIVATE_PERMISSION,
         PermissionKey.CONSORTIUM_MODULE_REACTIVATE_PERMISSION,PermissionKey.CONSORTIUM_MODULE_ADD_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.CONSORTIUM_MODULE);
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CONSORTIUM_MODULE_EDIT_PERMISSION})?.show?true:false;
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CONSORTIUM_MODULE_ADD_PERMISSION})?.show?true:false;
    this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CONSORTIUM_MODULE_REACTIVATE_PERMISSION})?.show?true:false;
    this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CONSORTIUM_MODULE_DEACTIVATE_PERMISSION})?.show?true:false;
  }

  get consortiumControls() { return this.consortiumForm.controls; }
  get vesselControl() { return this.consortiumControls.vesselDetails as FormArray; }
  get id(){ return this.consortiumForm.get('id'); }
  get name(){ return this.consortiumForm.get('name'); }
  get vesselDetails(){ return (this.consortiumForm.get('vesselDetails') as FormArray); }
  get destinationDetails(){ return (<FormArray>this.consortiumForm.get('destinationDetails')); }
  get lineDetails(){ return (<FormArray>this.consortiumForm.get('lineDetails')); }
  get consortiumServiceDetails(){ return (<FormArray>this.consortiumForm.get('consortiumServiceDetails')); }

}
